import AccessTimeTwoToneIcon from '@mui/icons-material/AccessTimeTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import AutoAwesomeMosaicTwoToneIcon from '@mui/icons-material/AutoAwesomeMosaicTwoTone';
import BorderAllRoundedIcon from '@mui/icons-material/BorderAllRounded';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CoPresentTwoToneIcon from '@mui/icons-material/CoPresentTwoTone';
import ConnectedTvTwoToneIcon from '@mui/icons-material/ConnectedTvTwoTone';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import ExitToAppTwoToneIcon from '@mui/icons-material/ExitToAppTwoTone';
import LaptopWindowsTwoToneIcon from '@mui/icons-material/LaptopWindowsTwoTone';
import ManageAccountsTwoToneIcon from '@mui/icons-material/ManageAccountsTwoTone';
import MenuIcon from '@mui/icons-material/Menu';
import MonetizationOnTwoToneIcon from '@mui/icons-material/MonetizationOnTwoTone';
import SettingsApplicationsTwoToneIcon from '@mui/icons-material/SettingsApplicationsTwoTone';
import { useMediaQuery } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';
import { Layout, Tag } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import packageJson from '../../../package.json';
import logo from '../../assets/img/nova-logo-branca.png';
import { usePermissions } from '../../contexts/permissionsContext';
import useAuth from '../../hooks/useAuth';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function DrawerPrincipal(props) {

  var div = props.divOpen.props.children.props.children;

  const { signout } = useAuth();
  const { getPermission, hasPermissionAction } = usePermissions();

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const usuario = JSON.parse(localStorage.getItem('user_token')) || {};

  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  React.useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);


  const handleLinkClick = () => {
    if (isMobile) {
      handleDrawerClose();
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar sx={{ bgcolor: '#000000' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerOpen}
            sx={{
              mr: 2,
              ...(open && !isMobile && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {usuario?.name || 'Usuário'}
          </Typography>

          <Layout>
            <Sider style={{ background: '#000000' }}></Sider>
            <Content style={{ background: '#000000' }}></Content>
            <Sider style={{ background: '#000000' }}>
              <Tag color={packageJson.ambiente === 'Homologação' ? 'orange' : '#000'}>
                {packageJson.ambiente}: {packageJson.version}
              </Tag>
            </Sider>
          </Layout>
        </Toolbar>
      </AppBar>

      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={open}
        onClose={handleDrawerClose}
      >
        <DrawerHeader style={{ background: '#000' }}>
          <img src={logo} width={'180'} height={'40'} />
          <IconButton style={{ color: '#FFF' }} onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>

          {
            hasPermissionAction("Dashboard", "isinsert") ?
              <Link to={"/"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <AutoAwesomeMosaicTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }

          {
            hasPermissionAction("Dashboard SCP", "isinsert") ?
              <Link to={"/dashboardscp"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/dashboardscp"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <DashboardTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard SCP"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }

          {
            hasPermissionAction("Cliente", "islist") ?
              <Link to={"/listCustomer"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/listCustomer"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <CoPresentTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Cliente"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }
          {
            hasPermissionAction("Serviço", "islist") ?
              <Link to={"/listService"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/listService"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <ManageAccountsTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Serviços"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }
          {
            hasPermissionAction("Painel", "islist") ?
              <Link to={"/listPanel"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/listPanel"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <ConnectedTvTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Painel"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }
          {
            hasPermissionAction("Circuito", "islist") ?
              <Link to={"/listCircuit"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/listCircuit"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <BorderAllRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Circuito"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }
        </List>
        <Divider />
        <List>
          {/* <Link to={"/availability"} style={{textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"Disponibilidade"} disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <EventAvailableTwoToneIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Disponibilidade"} />
                      </ListItemButton>
                </ListItem>
              </Link> */}
          <Link to={"/budgetList"} style={{ textDecorationLine: "none", color: "#707070" }}>
            <ListItem key={"/budgetList"} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <AccessTimeTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary={"Orçamento"} />
              </ListItemButton>
            </ListItem>
          </Link>
          {
            hasPermissionAction("Vendas", "islist") ?
              <Link to={"/listSale"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/listSale"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <MonetizationOnTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Venda"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :

              " "
          }
        </List>
        <Divider />
        <List>
          {
            hasPermissionAction("Usuario", "islist") ?
              <Link to={"/user"} style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"/user"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <AccountBoxTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Usuário"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }

          {
            hasPermissionAction("Suporte", "isinsert") ?

              <Link to="#"
                onClick={() => window.open("https://trendsuport3.glide.page", "_blank", "noopener,noreferrer")}
                style={{ textDecorationLine: "none", color: "#707070" }}>
                <ListItem key={"https://trendsuport3.glide.page"} disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <LaptopWindowsTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Suporte"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              ""
          }

          <Divider sx={{ my: 1 }} />

          {
            hasPermissionAction("Configuração", "islist") ?
              <Link to={"/listConfiguration"} onClick={handleLinkClick} style={{ textDecorationLine: "none", color: "#707070" }} >
                <ListItem key={"/listConfiguration"} disablePadding sx={{ mb: 0.5 }}>
                  <ListItemButton
                    onClick={handleLinkClick}
                    sx={{
                      borderRadius: 2,
                      '&:hover': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                      },
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.12)',
                        '&:hover': {
                          backgroundColor: 'rgba(25, 118, 210, 0.16)',
                        },
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <SettingsApplicationsTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={"Configurações"}
                      primaryTypographyProps={{
                        fontSize: '0.95rem',
                        fontWeight: 500,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              </Link>
              :
              null
          }

          <Link to={"#"} onClick={() => [signout(), navigate("/")]} style={{ textDecorationLine: "none", color: "#707070" }}>
            <ListItem key={"#"} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <ExitToAppTwoToneIcon />
                </ListItemIcon>
                <ListItemText onClick={() => [signout(), navigate("/")]} primary={"Sair"} />
              </ListItemButton>
            </ListItem>
          </Link>

        </List>

      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {div}
      </Box>
    </Box>
  );
}
